import { FormCheckbox } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { Field, FieldArray, formValues } from 'redux-form'
import bindActionCreators from 'redux/es/bindActionCreators'
import { Form, Icon, Segment, Table } from 'semantic-ui-react'
import ComponentHeader from '../Helper/ComponentHeader'

const i18nkey = 'admin.product.categories.ProductFamilyMembers.'

const mapStateToProps = (state, ownProps) => {
  const { properties } = state.properties
  return { properties }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class CategoryProperties extends React.Component {
  getRows({ fields }) {
    const getRows = ({ fields }) => {
      const { properties } = this.props //redux
      return fields.map((field, index, fields) => {
        return (
          <Table.Row verticalAlign="middle" key={index}>
            <Table.Cell>
              <Field
                component={({ input }) => {
                  const property =
                    properties.find(
                      (property) => property.id === input.value
                    ) || {}
                  return <div>{property.name_de}</div>
                }}
                name={`${field}.property_id`}
              />
            </Table.Cell>

            <Table.Cell collapsing>
              <Icon
                {...config.icons.delete}
                onClick={(event) => {
                  event.preventDefault()
                  fields.remove(index)
                }}
              />
            </Table.Cell>

            <Table.Cell collapsing>
              <Field
                component={FormCheckbox}
                name={`${field}.is_filter`}
                label="Filter"
              />
            </Table.Cell>
          </Table.Row>
        )
      })
    }

    return <Table.Body children={getRows({ fields })} />
  }

  render() {
    const { array } = this.props //redux
    const dark = config.theme.dark
    const { properties } = this.props //redux
    const { formProperties = [] } = this.props //formValues
    const categoryPropertyIds = formProperties.map(
      (categoryProperty) => categoryProperty.property_id
    )
    const remainingProperties = properties
      .filter((property) => !categoryPropertyIds.includes(property.id))
      .map((property) => ({ value: property.id, text: property.name_de }))

    return (
      <div className="CategoryProperties">
        <ComponentHeader
          icon={config.icons.filter}
          inline
          title={I18n.t(i18nkey + 'properties')}
        />
        <Segment attached className={classNames(['x', dark && 'inverted'])}>
          <Form.Dropdown
            {...{
              name: 'newCategoryPropertyId',
              options: remainingProperties,
              value: null,
              onChange: (event, data) =>
                array.push('properties', {
                  property_id: data.value,
                  is_filter: false,
                }),
              placeholder: I18n.t('admin.product.categories.select_property'),
              label: I18n.t('admin.product.categories.add_property'),
              search: true,
              selection: true,
            }}
          />
          <Table compact size="small" selectable singleLine basic="very">
            <FieldArray
              name="properties"
              component={(params) => this.getRows(params)}
            />
          </Table>
        </Segment>
      </div>
    )
  }
}

CategoryProperties = connect(mapStateToProps, mapDispatchToProps)(
  CategoryProperties
)
CategoryProperties = formValues({ formProperties: 'properties' })(
  CategoryProperties
)
export default CategoryProperties



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoryProperties.jsx